import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";
import type { Data } from "@/types/data";
import { ScrollArea } from "../ui/scroll-area";

interface FaqSectionProps {
	data: Data;
}

export function FaqSection({ data }: FaqSectionProps) {
	return (
		<div className="rounded-2xl border border-zinc-200 bg-white p-4 shadow-sm md:p-5">
			<ScrollArea className="h-[520px] pr-2 md:h-[560px]">
				<Accordion type="single" collapsible className="space-y-3">
					{data["area-duvidas"].duvidas
						.filter((duvida) => duvida.ativa)
						.map((duvida, index: number) => (
							<AccordionItem
								key={index}
								value={`item-${index}`}
								className="rounded-xl border border-zinc-200 bg-white px-4 shadow-xs transition-shadow hover:shadow-sm"
							>
								<AccordionTrigger className="py-4 text-base text-left text-zinc-900 hover:text-brand-700">
									{duvida.titulo}
								</AccordionTrigger>
								<AccordionContent className="pb-4 text-xs leading-relaxed text-zinc-600">
									{duvida.descricao}
								</AccordionContent>
							</AccordionItem>
						))}
				</Accordion>
			</ScrollArea>
		</div>
	);
}
